/**
 * ULTRACE — Global JS
 * Editorial Sport Modern
 */

(function () {
  'use strict';

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------
   * Scroll reveal
   * ---------------------------------------------------------- */
  const revealElements = document.querySelectorAll('[data-reveal], [data-reveal-stagger]');
  if (revealElements.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -60px 0px' }
    );
    revealElements.forEach((el) => observer.observe(el));
  } else {
    revealElements.forEach((el) => el.classList.add('revealed'));
  }

  /* ------------------------------------------------------------
   * Parallax (data-parallax="0.2" → translateY factor)
   * ---------------------------------------------------------- */
  if (!prefersReducedMotion) {
    const parallaxEls = Array.from(document.querySelectorAll('[data-parallax]'));
    if (parallaxEls.length) {
      let ticking = false;

      const update = () => {
        const viewportH = window.innerHeight;
        parallaxEls.forEach((el) => {
          const rect = el.getBoundingClientRect();
          if (rect.bottom < -200 || rect.top > viewportH + 200) return;
          const speed = parseFloat(el.dataset.parallax) || 0.2;
          const center = rect.top + rect.height / 2;
          const offset = (center - viewportH / 2) * speed;
          el.style.transform = `translate3d(0, ${offset.toFixed(2)}px, 0)`;
        });
        ticking = false;
      };

      const onScroll = () => {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
    }
  }

  /* ------------------------------------------------------------
   * Header scrolled state
   * ---------------------------------------------------------- */
  const header = document.querySelector('[data-site-header]');
  if (header) {
    const toggleScrolled = () => {
      header.classList.toggle('is-scrolled', window.scrollY > 24);
    };
    toggleScrolled();
    window.addEventListener('scroll', toggleScrolled, { passive: true });
  }

  /* ------------------------------------------------------------
   * Mobile nav toggle
   * ---------------------------------------------------------- */
  const burger = document.getElementById('nav-burger');
  const navLinks = document.getElementById('nav-links');
  if (burger && navLinks) {
    burger.addEventListener('click', () => {
      const open = navLinks.classList.toggle('site-header__links--open');
      burger.setAttribute('aria-expanded', String(open));
    });
  }

  /* ------------------------------------------------------------
   * Sous-menus de l'en-tête : ouverture au clic (et au survol sur ordinateur, en CSS),
   * fermeture au clic extérieur et avec Échap
   * ---------------------------------------------------------- */
  const parents = Array.from(document.querySelectorAll('.site-header__item--parent'));
  const closeAll = (except) => parents.forEach((p) => {
    if (p === except) return;
    p.classList.remove('is-open');
    const b = p.querySelector('.site-header__toggle'); if (b) b.setAttribute('aria-expanded', 'false');
  });
  parents.forEach((p) => {
    const btn = p.querySelector('.site-header__toggle');
    if (!btn) return;
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const open = !p.classList.contains('is-open');
      closeAll(p);
      p.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', String(open));
    });
  });
  if (parents.length) {
    document.addEventListener('click', (e) => { if (!e.target.closest('.site-header__item--parent')) closeAll(); });
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      const open = parents.find((p) => p.classList.contains('is-open'));
      closeAll();
      if (open) { const b = open.querySelector('.site-header__toggle'); if (b) b.focus(); }
    });
  }

  /* ------------------------------------------------------------
   * Marquee duplication (seamless loop)
   * ---------------------------------------------------------- */
  document.querySelectorAll('[data-marquee]').forEach((track) => {
    const clone = track.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    track.parentNode.appendChild(clone);
  });
})();
